import { call, put } from '@redux-saga/core/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { gatewayApi } from 'api/gatewayApi';
import { itemParam } from 'models';
import { GatewayInfo } from 'models/gateway';
import { takeLatest } from 'redux-saga/effects';
import { gatewayActions } from './gatewaySlice';
function* fetchGatewayInfoSaga(action: PayloadAction<itemParam>) {
  try {
    const response: GatewayInfo = yield call(gatewayApi.fetchGatewayInfo, {
      type: 'gateway_id',
      id: action.payload.id,
    });
    yield put(gatewayActions.fetchGatewayInfoSuccess({ ...action.payload, ...response }));
  } catch (error) {
    yield put(gatewayActions.fetchGatewayInfoFailed('fetch User info failed'));
  }
}

export default function* gatewaySaga() {
  yield takeLatest(gatewayActions.fetchGatewayInfo.type, fetchGatewayInfoSaga);
}
